export const convertToSeconds = (timeInMilli: number) => timeInMilli / 1000;
